import { ApiErrorSchema } from '../schemas/common';

export const defaultErrorResponses = {
  400: ApiErrorSchema,
  401: ApiErrorSchema,
  404: ApiErrorSchema,
  409: ApiErrorSchema,
  500: ApiErrorSchema,
  503: ApiErrorSchema,
};
